import type {EditedProperty} from 'typings/portaro.be.types';

export function prepareFormFields(formFields: EditedProperty[]): EditedProperty[] {
    return formFields.map((field) => {
        return {
            fieldName: field.fieldName,
            label: field.label,
            editor: {
                editorId: field.fieldName,
                editorName: field.fieldName,
                ...field.editor
            }
        }
    });
}

export function updateEditorsIsDisabledProperty(formFields: EditedProperty[], isDisabled: boolean): EditedProperty[] {
    return formFields.map((field) => ({...field, editor: {...field.editor, isDisabled}}));
}

export function updateEditorsModelProperty(formFields: EditedProperty[], models: Record<string, any>): EditedProperty[] {
    return formFields.map((field) => ({...field, editor: {...field.editor, model: models[field.fieldName]}}));
}